"use strict";

exports.__esModule = true;
exports.scriptVersion = void 0;
const scriptVersion = "1.0.290";
exports.scriptVersion = scriptVersion;